package games.polyclub.website.frontend.store.pages

import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.message.unaryMinus
import games.polyclub.website.frontend.store.context.addBreadcrumb
import games.polyclub.website.frontend.store.layout.PageBody
import games.polyclub.website.frontend.store.layout.PageHeader
import games.polyclub.website.frontend.store.sitemap.PublicSitemap
import react.Props

val GiveawayPurchaseTerms = SFC<Props> { _ ->
    addBreadcrumb(PublicSitemap.GIVEAWAY_PURCHASE_TERMS.pathPart, -"Termos e Condições para Compras de Produtos para Sorteio")

    PageHeader {
        title = -"Termos e Condições para Compras de Produtos para Sorteio na PolyClub"
    }
    PageBody {
        Card {
            h2 {
                +"1. Funcionamento do Sistema de Compras de Produtos para Sorteio"
            }
            p {
                +"1.1. A PolyClub oferece a opção de compra de produtos que serão inseridos em sorteios. Os produtos adquiridos serão incluídos em sorteios realizados por influenciadores parceiros ou pessoas autorizadas pela equipe PolyClub em redes sociais oficiais ou transmissões ao vivo."
            }
            p {
                +"1.2. Os produtos comprados entram em uma fila para sorteio e serão sorteados posteriormente."
            }
            p {
                +"1.3. O candidato que ganhar o sorteio terá a oportunidade de reivindicar o produto seguindo as regras estabelecidas para o sorteio. Se o candidato não for qualificado ou o produto não for utilizado dentro do prazo estipulado, o produto será colocado em sorteio novamente."
            }

            h2 {
                +"2. Cancelamento de Compras"
            }
            p {
                +"2.1. O comprador compreende e concorda que as compras de produtos para sorteio não podem ser canceladas após um produto ter sido sorteado."
            }
            p {
                +"2.2. No entanto, o comprador tem o direito de converter o produto em um presente para alguém conhecido ou para uso próprio a qualquer momento. É importante ressaltar que, após 7 dias da compra, o cancelamento da compra (com devolução dos valores pagos) não estará mais disponível."
            }

            h2 {
                +"3. Aceitação dos Termos"
            }
            p {
                +"3.1. Para concluir uma compra de produtos para sorteio, o comprador deve marcar o checkbox indicando que entende e concorda com os termos estabelecidos."
            }
        }
    }
}
